/* istanbul ignore file */
export { ProgressTrackerRouteBasedComponent } from './progress-tracker-route-based.component';
